import script from "./BulkCvResolutionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkCvResolutionModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkCvResolutionModal.vue?vue&type=style&index=0&id=3bf6f1d4&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf6f1d4"]])

export default __exports__